import React from "react";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const CertifiedPractitionerHeading = (props) => {
  const { t } = useTranslation();
  return (
    <div>
      <p className="CertifiedPracHeading">
        {props?.isInstructor
          ? t(translationConstants.BecomeInstructor)
          : t(translationConstants.UPLOAD_QUALIFICATION)}
      </p>
      <p className="UploadCertificateText pt-2">
        {props?.isInstructor
          ? t(translationConstants.BECOME_INSTRUCTOR_DESCRIPTION)
          : t(translationConstants.UPLOAD_QUALIFICATION_TEXT)}
      </p>
    </div>
  );
};

export default CertifiedPractitionerHeading;
